import axios from 'axios';

export enum SensorDataTypes {
    T_HUMIDITY = 'h',
    T_TEMPERATURE = 't',
    T_LIGHT = 'l'
};

export class SensorData {

    public filterData( type: SensorDataTypes, order: 'asc' | 'desc', limit?: number ) {

        const params = [];
        params.push( "t=" + type );
        params.push( "order=" + order );
        if ( limit != null ) params.push( "n=" + limit );

        return axios.get( '/api/data/filter?' + params.join( '&' ) );
    }

}